import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseComponent, WmsDialogHeaderComponent, WmsDialogBodyComponent } from '@wms/components';
import { isAppleProduct } from '@wms/core';

@Component({
  selector: 'wms-shortcuts-dialog',
  standalone: true,
  imports: [
    CommonModule,
    WmsDialogHeaderComponent,
    WmsDialogBodyComponent
  ],
  templateUrl: './shortcuts-dialog.component.html',
  styleUrls: ['./shortcuts-dialog.component.less']
})
export class ShortcutsDialogComponent extends BaseComponent implements OnInit {

  @Output() onModalClose: EventEmitter<any> = new EventEmitter<any>();
  cmdTitle: string = '';
  secondCmdTitle: string = '';

  constructor() {
    super();
  }

  ngOnInit(): void {
    if (isAppleProduct) {
      this.cmdTitle = 'command';
      this.secondCmdTitle = 'option'
    } else {
      this.cmdTitle = 'Ctrl';
      this.secondCmdTitle = 'Alt'
    }
  }

  closeModal() {
    this.onModalClose.emit();
  }
}
